import { stringify } from 'qs';
import { Id } from '../types/Id';
import { authenticatedInstance } from './axiosInstance';
import { GetCompanyResponseDto } from './dtos/GetCompanyResponseDto';
import { PagedResult } from './dtos/pagedResult';

export interface CompaniesFiltersDto {
  fulltext?: string;
  categories?: string[];
  countryId?: Id;
  minCompanySize?: Id;
  maxCompanySize?: Id;
  certificationId?: Id;
  membershipId?: Id;
  textileCompanyType: 'manufacturer' | 'importer';
  items_per_page: number;
  offset: number;
}

export const getCompaniesList = (filters: CompaniesFiltersDto) => {
  const categories = filters.categories || [];

  const query = stringify({
    ...filters,
    categories: categories.filter((c) => c !== '-1').join('.'),
  });

  return authenticatedInstance.get<PagedResult<GetCompanyResponseDto>>(
    `/companies?${query}`
  );
};
